export default __webpack_public_path__ + "static/media/HL_Economics.71eb3514.svg";